import React, { useState, useRef, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import Skeleton from "react-loading-skeleton";
import { Typewriter } from "react-simple-typewriter";
import { UnoStoreHooks } from "@simulanisindia/ui";
import {
  ChatUserIcon,
  CloseIcon,
  CopyIcon,
  CrownIcon,
  ReturnIcon,
  SendIcon,
  SoundIcon,
  StopSoundIcon,
  BreadRightArrow,
  QuestionIcon,
  TutorialIcon,
  AIChatBot,
} from "../../assets/icons/icons";

import ChatBotImg from "../../assets/img/chatbotimg.png";
import ChatBotWhiteImg from "../../assets/img/chatbotimgwhite.png";
import axios from "axios";
import SpinnerLoader from "../../components/skeleton/loader";
const { useUnoSelector } = UnoStoreHooks;
const defaultPopUpState = { chatbot: false, helperBox: false };

const ChatBot = ({}) => {
  const [showPopup, setShowPopup] = useState(defaultPopUpState);
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state?.user?.user);
  const AI_AGENT_URL = configData?.config?.AI_AGENT_URL;
  const SHOW_CHATBOT = configData?.config?.SHOW_CHATBOT;
  const SHOW_WALKTHROUGH  = configData?.config?.SHOW_WALKTHROUGH ;
  const WALKTHROUGH_LINK = configData?.config?.WALKTHROUGH_LINK;
  const body = document.body;
  const textAreaRef = useRef(null);
  const messagesEndRef = useRef(null);
  const [height, setHeight] = useState("26px");
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [overflowY, setOverflowY] = useState("hidden");
  const [textLoading, setTextLoading] = useState(false);
  const [copyText, setCopyText] = useState("copy");
  const [isSpeaking, setIsSpeaking] = useState({ id: null, status: false });
  const [chatboxActive, setChatboxActive] = useState(false);
  let userName = (userData?.name || "").split(" ");
  let initials =
    userName.length >= 1
      ? userName[0].charAt(0).toUpperCase() +
        (userName.length > 1 ? userName[userName.length - 1].charAt(0).toUpperCase() : "")
      : null;

  const sopSuggestions = ["How to start?", "What is Creator 360?"];

  const handleCopy = (text) => () => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    setCopyText("copied");
    setTimeout(() => setCopyText("copy"), 1000);
  };

  const toggleSpeak = (text, index) => {
    if (isSpeaking.status && isSpeaking.id === index) {
      window.speechSynthesis.cancel();
      setIsSpeaking({ id: null, status: false });
    } else {
      const utterance = new SpeechSynthesisUtterance(text);
      const voices = window.speechSynthesis.getVoices();
      utterance.voice = voices[2] || voices[0];
      window.speechSynthesis.speak(utterance);
      setIsSpeaking({ id: index, status: true });
    }
  };

  const openChatBox = (key) => {
    setShowPopup((prev) => ({ ...defaultPopUpState, [key]: !prev[key] }));
    if (!showPopup.chatbot) {
      body.classList.add("filter-active");
    } else {
      body.classList.remove("filter-active");
    }
  };

  const goBackToSuggestions = () => {
    setMessages([]);
    setInputValue("");
    setChatboxActive(false);
    setTextLoading(false);
  };

  const handleChange = (e) => {
    setInputValue(e.target.value);
    updateTextAreaHeight();
  };

  const updateTextAreaHeight = () => {
    if (textAreaRef.current) {
      textAreaRef.current.style.height = "auto";
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
      setHeight(`${textAreaRef.current.scrollHeight}px`);
      setOverflowY(textAreaRef.current.scrollHeight > 100 ? "auto" : "hidden");
    }
  };

  const handleSubmit = async () => {
    setChatboxActive(true);
    const userInput = inputValue.trim();
    if (!userInput) return;

    setMessages((prev) => [...prev, { request: userInput }]);
    setInputValue("");
    setTextLoading(true);

    try {
      const { data } = await axios.post(`${AI_AGENT_URL}/api/v1/ai/creatorchat`, {
        user_query: userInput,
      });
      setTextLoading(false);
      setMessages((prevMessages) => [...prevMessages, { response: data.data }]);
    } catch (error) {
      console.log(error);
      setTextLoading(false);
      setMessages((prevMessages) => [
        ...prevMessages,
        { response: "Sorry for the inconvenience, please try after some time." },
      ]);
    }
  };

  const handleSubmitSuggetions = async (question) => {
    const userInput = question.trim(); // mi
    setChatboxActive(true);
    if (!question.trim()) return;

    setMessages((prev) => [...prev, { request: userInput }]); // mi
    setTextLoading(true);
    try {
      const { data } = await axios.post(`${AI_AGENT_URL}/api/v1/ai/creatorchat`, {
        user_query: userInput,
      });

      setTextLoading(false);
      setMessages((prevMessages) => [...prevMessages, { response: data.data }]);
    } catch (error) {
      console.log(error);
      setTextLoading(false);
      setMessages((prevMessages) => [
        ...prevMessages,
        { response: "Sorry for the inconvenience, please try after some time." },
      ]);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit();
    }
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const handleSpeechEnd = () => {
      setIsSpeaking((prev) => ({ ...prev, status: false }));
    };

    window.speechSynthesis.addEventListener("end", handleSpeechEnd);
    return () => {
      window.speechSynthesis.removeEventListener("end", handleSpeechEnd);
    };
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    updateTextAreaHeight();
  }, [inputValue]);

  return (
    <>
      <div className="helpWrapperParent">
        <div className="helpWrapper">
          <button className="helpButton">
            <QuestionIcon />
          </button>

          {SHOW_WALKTHROUGH  && (
            <button
              className="walkthrough"
              onClick={() => {
                openChatBox("helperBox");
              }}
            >
              <TutorialIcon />
              {!showPopup.chatbot && !showPopup.helperBox && <p className="tooltip">Interactive walkthrough</p>}
            </button>
          )}

          {SHOW_CHATBOT && (
            <button
              className="bot-here"
              onClick={() => {
                openChatBox("chatbot");
                setChatboxActive(false);
              }}
            >
              {!showPopup.chatbot && !showPopup.helperBox && <p className="tooltip">AI Chatbot</p>}

              <AIChatBot />
            </button>
          )}
        </div>

        {showPopup.chatbot && (
          <span className="chat-here">
            <div className="chat-content">
              {messages.length === 0 ? (
                <div className="greet-screen w-100">
                  <img src={ChatBotWhiteImg} alt="chatbot white" />
                  <p>
                    Welcome {userName}
                    <br />
                    How can I help you today?
                  </p>
                  <div className="temp-ques">
                    {sopSuggestions.map((question, index) => (
                      <span key={index} onClick={() => handleSubmitSuggetions(question)} className="ques-item">
                        {question}
                        <span className="click-que">
                          <BreadRightArrow />
                        </span>
                      </span>
                    ))}
                  </div>
                </div>
              ) : null}

              {messages.length === 0 ? (
                <span className="close-btn" onClick={openChatBox}>
                  <CloseIcon />
                </span>
              ) : (
                <div className="close-pannel">
                  <span className="close-btn" onClick={goBackToSuggestions}>
                    <ReturnIcon />
                  </span>
                  <span className="close-btn" onClick={openChatBox}>
                    <CloseIcon />
                  </span>
                </div>
              )}

              <div className="for-prompts">
                {messages.map((message, i) => (
                  <React.Fragment key={i}>
                    {message.request && (
                      <div className="promptext">
                        {userData.avatar ? (
                          <img className="user-ini ai" src={userData.avatar}></img>
                        ) : (
                          <span className="user-ini">{initials}</span>
                        )}
                        <span className="promt-info">
                          <p>You</p>
                          <p>{message.request}</p>
                        </span>
                      </div>
                    )}

                    {i === messages.length - 1 && textLoading && (
                      <div className="promptext">
                        <img src={ChatBotImg} className="user-ini ai" alt="chatbot-img" />
                        <span className="promt-info">
                          <p>Assistant</p>
                          <p className="w-100">
                            <Skeleton count={2} width="20vw" baseColor="#566FF950" highlightColor="#FF7C7C50" />
                          </p>
                        </span>
                      </div>
                    )}

                    {message.response && (
                      <div className="promptext">
                        <img src={ChatBotImg} className="user-ini ai" alt="chatbot-img" />
                        <span className="promt-info">
                          <p>Assistant</p>
                          {chatboxActive && i === messages.length - 1 ? (
                            <Typewriter words={[message.response]} typeSpeed={20} />
                          ) : (
                            <p>{message.response}</p>
                          )}
                          <div className="mini-featurs">
                            <Tooltip title={isSpeaking.status && isSpeaking.id === i ? "Stop" : "Read Aloud"}>
                              <span onClick={() => toggleSpeak(message.response, i)}>
                                {isSpeaking.status && isSpeaking.id === i ? <StopSoundIcon /> : <SoundIcon />}
                              </span>
                            </Tooltip>
                            <Tooltip title={copyText}>
                              <span onClick={handleCopy(message.response)}>
                                <CopyIcon />
                              </span>
                            </Tooltip>
                          </div>
                        </span>
                      </div>
                    )}
                  </React.Fragment>
                ))}
                <div ref={messagesEndRef} />
              </div>

              <div className="for-input">
                <textarea
                  ref={textAreaRef}
                  value={inputValue}
                  onChange={handleChange}
                  placeholder="Type your message here"
                  style={{ overflowY }}
                  onKeyDown={handleKeyDown}
                />
                <span onClick={handleSubmit} className="send-btn">
                  <SendIcon />
                </span>
              </div>
            </div>
          </span>
        )}

        {(showPopup.chatbot || showPopup.helperBox) && <OverLay closeHandler={setShowPopup} />}
      </div>
      {showPopup.helperBox && <HelperBox iframeLink={WALKTHROUGH_LINK} closeHandler={setShowPopup} />}
    </>
  );
};

export default ChatBot;

export const HelperBox = ({ iframeLink = "", closeHandler = () => {} }) => {
  const [delayLoading, setDelayLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => setDelayLoading(() => false), 1000);
  }, []);
  return (
    <div className="helper-box">
      <div className="iframeParent">
        {delayLoading && (
            <SpinnerLoader />
        )}
        <iframe
          src={iframeLink}
          title="Helper Box"
          allowfullscreen
          webkitallowfullscreen
          mozallowfullscreen
          allowtransparency
        />
      </div>
      <span className="closeIcon" onClick={() => closeHandler(defaultPopUpState)}>
        <CloseIcon />
      </span>
    </div>
  );
};

export const OverLay = ({ closeHandler = () => {} }) => {
  return <div className="showoverlay" onClick={() => closeHandler(defaultPopUpState)}></div>;
};
